import Icon from '../components/Icon.vue'

Icon.register({"broom":{"width":512,"height":512,"paths":[{"d":"M10.8 247.2C-0.7 251.8-3.7 266.7 5 275.4L59.8 330.2 133 305.8 108.6 379 236.6 507C245.4 515.8 260.2 512.7 264.8 501.2L362.9 257.5 254.5 149.1 10.8 247.2zM507.3 27.3L484.7 4.7C478.5-1.6 468.3-1.6 462.1 4.7L359.8 106.9 319.4 66.5C315.2 62.2 308 63.5 305.5 69L278.3 127.6 384.4 233.7 443 206.5C448.4 204 449.7 196.8 445.5 192.6L405.1 152.2 507.3 49.9C513.6 43.7 513.6 33.6 507.3 27.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/broom.js
// module id = zXC0
// module chunks = 0